module.exports = __webpack_public_path__ + "media/cloche.e48524fa.wav";